import {put,takeLatest,call} from 'redux-saga/effects'
import * as superUserService from "../../../services/superUserService"
import {
    ADD_SUPERUSER,
    ADD_SUPERUSER_SUCCESS,
    ADD_SUPERUSER_ERROR
}
    from "../../actions/superuser"

function* addSuperUserSaga(action) {
    try {
        const data=yield call(superUserService.AddSuperUser,action.payload)
        yield put({
            type: ADD_SUPERUSER_SUCCESS,
            payload: data
        })

    } catch(error) {
        yield put({
            type: ADD_SUPERUSER_ERROR,error: error.data
        })
    }
}


export function* addSuperUserSagaWatcher() {
    yield takeLatest(ADD_SUPERUSER,addSuperUserSaga)
}